module.exports = __webpack_public_path__ + "img/emoji_43.1a8499cd.png";